import axios from 'axios';
import { ChatResponse, SuggestedQuestionsResponse } from './types';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost/api';

export class HelpChatbotService {
  /**
   * Send a chat message and get AI response
   */
  static async sendMessage(query: string, options?: {
    model?: string;
    temperature?: number;
    max_tokens?: number;
    top_k?: number;
  }): Promise<ChatResponse> {
    try {
      const response = await axios.post<ChatResponse>(
        `${API_BASE_URL}/help_chatbot/chat`,
        {
          query,
          options: options || {}
        }
      );
      return response.data;
    } catch (error: any) {
      console.error('Help chatbot error:', error);
      throw new Error(
        error.response?.data?.message || 'Failed to get response from chatbot'
      );
    }
  }

  /**
   * Search for relevant documentation
   */
  static async searchDocumentation(query: string, topK: number = 5) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/help_chatbot/search`,
        {
          query,
          top_k: topK
        }
      );
      return response.data;
    } catch (error: any) {
      console.error('Search error:', error);
      throw new Error(
        error.response?.data?.message || 'Failed to search documentation'
      );
    }
  }

  /**
   * Check chatbot status
   */
  static async getStatus() {
    try {
      const response = await axios.get(`${API_BASE_URL}/help_chatbot/status`);
      return response.data;
    } catch (error: any) {
      console.error('Status check error:', error);
      throw new Error('Failed to check chatbot status');
    }
  }

  /**
   * Get suggested questions
   */
  static async getSuggestedQuestions(): Promise<SuggestedQuestionsResponse> {
    try {
      const response = await axios.get<SuggestedQuestionsResponse>(
        `${API_BASE_URL}/help_chatbot/suggested_questions`
      );
      return response.data;
    } catch (error: any) {
      console.error('Suggested questions error:', error);
      throw new Error('Failed to get suggested questions');
    }
  }

  /**
   * Submit contact form for unanswered queries
   */
  static async submitContactForm(data: {
    name: string;
    email: string;
    phone: string;
    query: string;
  }) {
    try {
      // You'll need to create this endpoint in your API
      const response = await axios.post(
        `${API_BASE_URL}/help_chatbot/contact`,
        data
      );
      return response.data;
    } catch (error: any) {
      console.error('Contact form error:', error);
      throw new Error(
        error.response?.data?.message || 'Failed to submit contact form'
      );
    }
  }
}
